module.exports = __webpack_public_path__ + "src/assets/images/list_logo.png";